<template>
  <div>
    <hshead title="约拍城市" waveBg="true"></hshead>
    <div class="city-top">
      <div class="top-left">
        <div class="this-p">已通过：10</div>
        <div class="this-p">审核中：2</div>
      </div>
      <div class="top-right">
        <div class="this-img">
          <img src="../assets/images/city/city.png" alt />
        </div>
        <router-link to class="this-btn">申请约拍城市</router-link>
      </div>
    </div>
    <div class="city-ul">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="city-li" v-for="(item, index) in list" :key="index">
          <div class="left-icon">
            <img src="../assets/images/city/tempCity.png" alt />
          </div>
          <div class="center-p">
            <div class="center-h1">广东省广东市</div>
            <div class="center-time">2018-05-01 22:09</div>
          </div>
          <div class="right-icon">
            <img src="../assets/images/city/icon.png" alt />
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { List } from "vant";
export default {
  name: "city",
  data() {
    return {
      list: [],
      loading: false,
      finished: false
    };
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    }
  },
  components: {
    hshead,
    "van-list": List
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.city-top {
  display: flex;
  margin-top: -3.5rem;
  .top-left {
    width: 3.41rem;
    height: 1.04rem;
    border-right: 1px solid rgba(255, 255, 255, 0.6);
    .this-p {
      font-family: PingFang-SC-Medium;
      font-size: 0.3rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #ffffff;
      padding-left: 1rem;
      padding-top: 0.15rem;
    }
  }
  .top-right {
    flex: 1;
    display: flex;
    .this-img {
      width: 1.9rem;
      text-align: center;
      img {
        width: 0.83rem;
        height: 0.87rem;
        display: inline-block;
      }
    }
    .this-btn {
      display: block;
      text-align: center;
      margin-top: 0.3rem;
      width: 1.65rem;
      height: 0.51rem;
      background-color: #f3f9fe;
      border-radius: 0.06rem;
      opacity: 0.8;
      font-family: PingFang-SC-Medium;
      font-size: 0.24rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.51rem;
      letter-spacing: 0rem;
      color: #4570f6;
    }
  }
}
.city-ul {
  margin-top: 1.9rem;
  margin-bottom: 0.4rem;
  .city-li {
    width: 6.7rem;
    height: 2.01rem;
    background-color: #fff;
    box-shadow: 0rem 0.01rem 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.06rem;
    display: flex;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    .left-icon {
      width: 2.08rem;
      text-align: center;
      padding-top: 0.4rem;
      img {
        width: 1.17rem;
        height: auto;
        display: inline-block;
      }
    }
    .center-p {
      width: 3.48rem;
      padding-top: 0.4rem;
      .center-h1 {
        font-family: PingFang-SC-Medium;
        font-size: 0.28rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0.01rem;
        color: #333333;
        padding-bottom: 0.35rem;
      }
      .center-time {
        font-family: PingFang-SC-Medium;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0.01rem;
        color: #808d9e;
      }
    }

    .right-icon {
      width: 0.9rem;
      padding-top: 0.14rem;
      img {
        width: 0.9rem;
        height: 0.89rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/city.vue